export const FETCH_COUPON_SOURCES = '@promo/FETCH_COUPON_SOURCES';
export const FETCH_COUPON_SOURCES_SUCCESS = '@promo/FETCH_COUPON_SOURCES_SUCCESS';
export const FETCH_COUPON_SOURCES_FAILURE = '@promo/FETCH_COUPON_SOURCES_FAILURE';

export const GENERATE_COUPON = '@promo/GENERATE_COUPON';
export const GENERATE_COUPON_SOURCE_NOT_FOUND = '@promo/GENERATE_COUPON_SOURCE_NOT_FOUND';
export const GENERATE_COUPON_SUCCESS = '@promo/GENERATE_COUPON_SUCCESS';
export const GENERATE_COUPON_FAILURE = '@promo/GENERATE_COUPON_FAILURE';

